export const statements = {
    "A1.1": {
      id: "A1.1",
      statement:
        "Jag vägleder i enlighet med lagstiftningen och de administrativa anvisningarna inom min bransch.",
    },
    "A1.2": {
      id: "A1.2",
      statement:
        "Jag är medveten om gränserna för mitt yrke och min kompetens och agerar därefter.",
    },
    "A1.3": {
      id: "A1.3",
      statement: "Jag agerar i enlighet med de etiska principerna inom mitt område.",
    },
    "A1.4": {
      id: "A1.4",
      statement:
        "I vägledningsrelationen agerar jag i enlighet med de etiska principerna inom min bransch. ",
    },
    "A2.1": {
      id: "A2.1",
      statement: "Jag baserar mitt arbete på centrala teorier och forskningsdata inom området.",
    },
    "A2.2": {
      id: "A2.2",
      statement: "Jag tillämpar ett brett spektrum av teorier i vägledningsarbetet.",
    },
    "A2.3": {
      id: "A2.3",
      statement:
        "Jag följer forskning och annan litteratur inom vägledningsområdet, samt med tanke på mitt arbete relevanta aktörers och vetenskapsområdens publikationer.",
    },
    "A3.1": {
      id: "A3.1",
      statement:
        "Jag utvärderar och utvecklar mitt vägledningsarbete tillsammans med kunder, kollegor, olika aktörer och intressegrupper inom vägledning.",
    },
    "A3.2": {
      id: "A3.2",
      statement:
        "Jag är engagerad i att identifiera mina egna utvecklingsmål och sträva efter kontinuerlig professionell utveckling.",
    },
    "A4.1": {
      id: "A4.1",
      statement:
        "Jag använder muntlig, skriftlig och visuell kommunikation på ett tydligt och begripligt sätt. ",
    },
    "A4.2": {
      id: "A4.2",
      statement:
        "Jag använder mig av olika kanaler, metoder och verktyg i kommunikation och interaktion.",
    },
    "A4.3": {
      id: "A4.3",
      statement:
        "Jag behärskar muntlig och skriftlig kommunikation, både i realtid och fördröjd, samt skapar och upprätthåller dialoger med kunden/grupperna. ",
    },
    "A4.4": {
      id: "A4.4",
      statement:
        "Jag kommunicerar i egenskap av sakkunnig inom kundservice och som representant för vägledningsbranschen i olika nätverk och arbetsgrupper.",
    },
    "A5.1": {
      id: "A5.1",
      statement:
        "Jag utnyttjar teknologi i vägledningen på ett effektivt och ändamålsenligt sätt. ",
    },
    "A5.2": {
      id: "A5.2",
      statement: "Jag använder smidigt teknologi i vägledningsprocessen. ",
    },
    "A5.3": {
      id: "A5.3",
      statement:
        "Jag främjar kollaborativ användning av teknologi i vägledningsprocessen och inom professionellt samarbete. ",
    },
    "A5.4": {
      id: "A5.4",
      statement:
        "Jag utnyttjar nya teknologiska lösningar och främjar användningen av dem i vägledningsprocessen.",
    },
    "B1.1": {
      id: "B1.1",
      statement:
        "Vid sidan av individens egen utveckling betraktar jag vägledning som en serviceprocess och samhällelig aktivitet. ",
    },
    "B1.2": {
      id: "B1.2",
      statement:
        "Jag tar hänsyn till vägledningens informations-, interaktions- och processdimensioner.",
    },
    "B1.3": {
      id: "B1.3",
      statement:
        "Tillsammans med kunden utvärderar jag systematiskt resultaten och effekterna av vägledningsprocessen.",
    },
    "B2.1": {
      id: "B2.1",
      statement:
        "Jag ser på vägledningen ur individens perspektiv, separat som utvecklingsprocess, livssituation och dess sammanhang.",
    },
    "B2.2": {
      id: "B2.2",
      statement:
        "Jag ser på karriärutveckling utgående från individens egenskaper, intressen, värderingar och sammanhang.",
    },
    "B2.3": {
      id: "B2.3",
      statement:
        "Jag ser på mitt arbete som en del av den sociala och kulturella verklighet som påverkar kundens situation.",
    },
    "B2.4": {
      id: "B2.4",
      statement:
        "Jag tillämpar vägledningsteorier som tar hänsyn till individen och dennes kontext på ett kundorienterat sätt.",
    },
    "B2.5": {
      id: "B2.5",
      statement:
        "Jag säkerställer att kunder och grupper lär sig att bedöma och utveckla sina styrkor och kompetenser i förhållande till de möjligheter som verksamhetsmiljön erbjuder.",
    },
    "B2.6": {
      id: "B2.6",
      statement:
        "Jag granskar min egen och kundens världsbild genom att medvetandegöra begrepp och strukturer.",
    },
    "B3.1": {
      id: "B3.1",
      statement:
        "Jag ser till att kunder, grupper och jag själv har tillgång till aktuella informationskällor som stöd för planer och beslut gällande livet, studierna och arbetet.",
    },
    "B3.2": {
      id: "B3.2",
      statement:
        "Jag kartlägger kundens eller gruppen vägledningsbehov och ställer upp målen för vägledningsprocessen tillsammans med kunden eller gruppmedlemmarna.",
    },
    "B3.3": {
      id: "B3.3",
      statement:
        "Jag planerar och genomför tillsammans med kunderna en vägledningsprocess som motsvarar deras beredskap och behov. ",
    },
    "B3.4": {
      id: "B3.4",
      statement:
        "Tillsammans med kunden utvärderar jag resultaten och effekterna av vägledningsprocessen. ",
    },
    "C1.1": {
      id: "C1.1",
      statement:
        "I mitt arbete tar jag hänsyn till fenomen, relationer, trender och förändringar i utbildning, arbetsliv och samhälle. ",
    },
    "C1.2": {
      id: "C1.2",
      statement:
        "Jag säkerställer att livslång vägledning utgör ett kontinuum i kärnan av livslångt och kontinuerligt lärande.",
    },
    "C1.3": {
      id: "C1.3",
      statement:
        "Jag följer aktuell forskning och deltar i samhällsdebatten inom området.",
    },
    "C2.1": {
      id: "C2.1",
      statement:
        "Jag tillämpar organisations- och nätverksteorier för att definiera gemensamt överenskomna mål för vägledning och för att planera, genomföra och utvärdera tjänster.",
    },
    "C2.2": {
      id: "C2.2",
      statement:
        "Jag utvecklar vägledningen som en del av ett bredare samhälleligt sammanhang och olika organisationers servicestruktur.",
    },
    "C3.1": {
      id: "C3.1",
      statement: "Jag samarbetar multiprofessionellt med andra yrkesgrupper.",
    },
    "C3.2": {
      id: "C3.2",
      statement: "Jag samarbetar med olika organisationer.",
    },
    "C4.1": {
      id: "C4.1",
      statement:
        "Jag planerar och organiserar vägledningsarbetet i enlighet med lokala behov och verksamhetsförutsättningar samt administrativa anvisningar och bestämmelser.",
    },
    "C4.2": {
      id: "C4.2",
      statement:
        "Jag främjar en systematisk bedömning av vägledningens kvalitet och genomslagskraft.",
    },
    "C4.3": {
      id: "C4.3",
      statement:
        "Jag undersöker de underliggande principerna, värderingarna, uppfattningarna, strukturerna, riktlinjerna och de praktiska verksamhetsförutsättningarna för vägledning.",
    },
  };